import FormPhoneAndOTP from "@components/inputs/FormPhoneAndOTP";
import FormUsernamePassword from "@components/inputs/FormUsernamePassword";
import { usePostLoginCheck } from "@components/utils/Auth/hooks";
import { LoginCallbackProps } from "@components/utils/Auth/types";
import { SEON_FEATURE } from "@configs/seon";
import { useSeonSession } from "@hooks/useSeonSession";
import { t } from "i18next";
import { AuthSocial } from "../../AuthSocial";

interface LoginUPProps extends LoginCallbackProps {
  defaultMethod: "phone" | "username";
  onAccountLocked?: (isLocked: boolean, remainingTime?: number) => void;
  isAccountLocked?: boolean;
  lockedRemainingTime?: number;
}

const LoginUP = ({
  defaultMethod,
  onAccountLocked,
  isAccountLocked,
  onLoginSuccess,
  onForgotSecret,
  lockedRemainingTime,
}: LoginUPProps) => {
  const postLoginCheck = usePostLoginCheck({
    onLoginSuccess,
  });

  useSeonSession(SEON_FEATURE.LOGIN, {
    autoInit: true,
  });

  return (
    <>
      {defaultMethod === "phone" && (
        <div className="w-full animate-fade-in">
          <FormPhoneAndOTP
            onLoginSuccess={postLoginCheck}
            onForgotSecret={onForgotSecret}
            onAccountLocked={onAccountLocked}
            isAccountLocked={isAccountLocked}
            lockedRemainingTime={lockedRemainingTime}
          />
        </div>
      )}

      {defaultMethod === "username" && (
        <div className="w-full animate-fade-in">
          <FormUsernamePassword
            onLoginSuccess={postLoginCheck}
            onForgotSecret={onForgotSecret}
            onAccountLocked={onAccountLocked}
            isAccountLocked={isAccountLocked}
            lockedRemainingTime={lockedRemainingTime}
          />
        </div>
      )}

      {/* SOCIAL AUTH */}
      <AuthSocial
        mode="login"
        title={t("or")}
        onLoginSuccess={postLoginCheck}
        className="mt-2"
      />
    </>
  );
};

export default LoginUP;
